import Script from 'next/script';
import { ReactElement, createContext, useContext, useEffect, useState } from 'react';
// import { onLoadScript } from '/scripts/onloadAppsflyerScript';
import { usePathname } from 'next/navigation';
import { onLoadScript } from 'public/scripts/onloadAppsflyerScript';



interface OneLinkContextType {
    oneLinkUrl: string;
    isScriptLoaded: boolean;
}


// Create a context for the URL
const OneLinkContext = createContext<OneLinkContextType | undefined>(undefined);

// Create a custom hook to use the OneLinkContext
export const useOneLinkUrl = () => {
    const context = useContext(OneLinkContext);
    if (!context) {
        throw new Error('useOneLinkUrl must be used within a OneLinkScriptWrapper');
    }
    return context;
};

type Props = {
    children: ReactElement | ReactElement[]
};

// Create the OneLinkScriptWrapper component
export const OneLinkScriptProvider = ({ children }: Props) => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const [url, setUrl] = useState("https://www.example.com");
    const pathname = usePathname();

    const handleLoadOneLinkScript = () => setIsScriptLoaded(true);
    const getUrl = () => {
        try {
            const oneLinkUrl = onLoadScript();
            setUrl(oneLinkUrl);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error while loading AppsFlyer script:', error);
        }
    }

    useEffect(() => {
        if (isScriptLoaded) {
            getUrl();
        }
    }, [isScriptLoaded, pathname]);

    return (
        <OneLinkContext.Provider value={{ oneLinkUrl: url, isScriptLoaded }}>
            {children}
            <Script
                src="/scripts/appsflyer-onelink.js"
                strategy="lazyOnload"
                onLoad={handleLoadOneLinkScript}
            />
        </OneLinkContext.Provider>
    );
};
